import React, { useEffect } from "react";
import Card from "components/card";
import { Form, Input, Select } from 'antd';
import FormItem from "components/fields/FormItem";
import { connect } from "react-redux";
import { 
	getAccessGroupUserDetails, doAccessGroupUserCreate, doAccessGroupUserUpdate 
} from "../../../../../redux/accessgroupuser/accessGroupUserState";
import { useForm } from 'antd/lib/form/Form';
import { requiredField } from '../../../../../utils/crudSagaHelper';
import CrudButtons from "components/button/crudbuttons";

const AccessGroupUserForm = ({getRecord, doCreate, doUpdate, recordData, requesting, ...props}) => {
	
  	const { recordId, mode } = props;  	
  	const [form] = useForm();
  	useEffect(() => {
        getRecord(recordId);
	}, [getRecord, recordId]);
	
	useEffect(() => {
		if(recordData){			
			const { ...rest } = recordData;
	        const initialValues = {
	            ...rest,
	        };
	        
	        form.setFieldsValue(initialValues);
        }
    }, [recordData, form]);
    
  	const onSubmit = (values) => {	
    	try {							
			recordData.acr_id > 0 ? doUpdate(values): doCreate(values); 
    	} catch (error) {
      		console.error('Save failed:', error);
    	}
  	};
  
  	return (
    	<Card extra={"w-full h-full p-4"}>
		  	<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
		  		layout="vertical"
		  		onFinish={onSubmit}
	        >   
	        	<FormItem
			        name="acr_id"
			        hidden
			    >
			        <Input type="hidden"/>
			    </FormItem>
        		<div className="grid grid-cols-3 gap-4">
        			<FormItem className="font-medium mb-2"
		            	name="acr_access_group_id"
		                label="Role/Group"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_access_group_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.accessGroupOptionList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.acr_access_group_name}</label>
		            	}	                
	            	</FormItem>  

					<FormItem className="font-medium mb-2"
		            	name="acr_module_id"
		                label="Module"
		                rules={[requiredField()]}
		            >
		            	{mode === 'edit' ?
		            	<Select id="acr_module_id"
		            		showSearch
		            		allowClear={true}
		            		style={{
						        width: 250,
						      }}
						    options={recordData?.moduleOptionList}
						    filterOption={(input, option) =>
						      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
						    }
		            	/>
		            	: <label className="ps-3 dark:text-white">{recordData?.acr_module_name}</label>
		            	}	                
	            	</FormItem>
				</div>
				 	
	 			<CrudButtons baseRoute="/console/access-rights" mode={mode} recordId={recordId} />			 			
	 		</Form>	 	
	 	</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.accessGroupUser.accessGroupUserDetails?.data,
  	requesting: state.accessGroupUser.accessGroupUserDetails?.requesting,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getAccessGroupUserDetails(id)),
  	doCreate: (data) => dispatch(doAccessGroupUserCreate(data)),
  	doUpdate: (data) => dispatch(doAccessGroupUserUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessGroupUserForm);
